import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";
import "./Users.css";

export default function UsersCreate() {
  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const navigate = useNavigate();

  const handleCreate = async () => {
    if (role === "") {
      alert("Please choose a role before submitting!");
      return;
    }

    try {
      const res = await api.post("/users/create", { email, password, role });
      setUsers([...users, res.data]);
      setEmail(""); setPassword(""); setRole("User");
      navigate("/users");
    } catch (err) {
      alert(err.response?.data || "Error creating user");
    }
  };

  const handleCancel = () => {
      navigate("/users/all");
    };

  return (
    <div className="create-user">
      <h1>Create User</h1>
      <div className="create-form-conteiner">
        <div className="input-conteiner">
          <div className="inputs">
            <div className="label">Email<span className="required">*</span></div>
            <input name="email" type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="inputs">
            <div className="label">Password<span className="required">*</span></div>
            <input name="password" type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
        </div>
        <div className="role-select">
          <div className="label">Role<span className="required">*</span></div>
          <select value={role} onChange={e => setRole(e.target.value)} required>
            <option value="">Please choose role</option>
            <option value={1}>Admin</option>
            <option value={2}>Moderator</option>
            <option value={3}>User</option>
          </select>
        </div>
        <div className="form-btn">
          <div className="submit-btn">
            <button onClick={handleCreate}>Create</button>
          </div>
          <button onClick={handleCancel} className="cancel-btn">
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );
}